export const LIST_ROW_TITLE_CLASS =
  'font-extrabold text-[14.5px] text-[var(--naia-text-primary)] line-clamp-2 break-words min-w-0';

export const LIST_ROW_META_CLASS =
  'flex flex-wrap items-center gap-x-1.5 gap-y-0.5 text-[12px] text-[var(--naia-text-secondary)] mt-[1px]';

export const fmtListDate = (iso: string) =>
  new Date(iso).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' });

export const fmtListDateShort = (iso: string) =>
  new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: '2-digit' });
